// ─── MONTH NAME MAP ───────────────────────────────────────────────────────────
export const MONTH_NAMES = {
  JAN: "January",  FEB: "February", MAR: "March",
  APR: "April",    MAY: "May",      JUN: "June",
  JUL: "July",     AUG: "August",   SEP: "September",
  OCT: "October",  NOV: "November", DEC: "December",
};

// ─── SAFE DATE PARSER (handles DD/MM/YYYY and YYYY-MM-DD) ─────────────────
export const safeParseDate = (dateStr) => {
  if (!dateStr) return new Date(NaN);
  // Check for DD/MM/YYYY format first
  const dmyMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmyMatch) {
    return new Date(Number(dmyMatch[3]), Number(dmyMatch[2]) - 1, Number(dmyMatch[1]));
  }
  return new Date(dateStr);
};

// ─── DATE FORMATTER ───────────────────────────────────────────────────────────
export const formatDate = (dateStr) => {
  const d = safeParseDate(dateStr);
  if (isNaN(d.getTime())) return dateStr || "";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// ─── CATEGORIES (default fallback if API fails) ──────────────────────────────
export const FALLBACK_CATEGORIES = [
  { id: "all",      label: "All Events" },
];

export const MONTHS_ORDER = [
  "JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"
];

export const YEARS = [];


// ─── COUNTRY TO VISA ID MAP ───────────────────────────────────────────────────
export const COUNTRY_TO_VISA_ID = {
  "United States": "usa",
  "United Kingdom": "uk",
  "France": "france",
  "Bahrain": "bahrain",
  "Pakistan": "pakistan",
  "Japan": "japan",
  "India": "india",
  "Monaco": "monaco",
  "Germany": "germany",
  "Switzerland": "switzerland",
  "Italy": "italy",
  "South Korea": "south-korea",
  "Belgium": "belgium",
  "West Indies": "west-indies",
  "Netherlands": "netherlands",
  "Spain": "spain",
  "Australia": "australia",
  "UAE": "uae",
  "Canada": "canada",
  "Thailand": "thailand",
  "Vietnam": "vietnam",
  "Indonesia": "indonesia",
  "Malaysia": "malaysia",
  "Singapore": "singapore",
  "Turkey": "turkey",
  "Egypt": "egypt",
  "New Zealand": "new-zealand",
  "Hong Kong": "hong-kong",
  "Brazil": "brazil",
  "Saudi Arabia": "saudi-arabia",
};

// ─── FALLBACK IMAGE URL ────────────────────────────────────────────────────────
export const FALLBACK_IMAGE = "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80";

// ─── SCROLL OFFSET ─────────────────────────────────────────────────────────────
export const SCROLL_OFFSET = 120;

// ─── DEFAULT LABELS ────────────────────────────────────────────────────────────
export const DEFAULT_ALL_EVENTS = "All Events";
export const DEFAULT_ALL_MONTHS = "All Months";

export function monthCodeFromDate(dateValue) {
  const d = safeParseDate(dateValue);
  if (Number.isNaN(d.getTime())) return null;
  return MONTHS_ORDER[d.getMonth()] || null;
}

export function normalizeEvents(apiEvents) {
  if (!Array.isArray(apiEvents) || apiEvents.length === 0) return [];

  const seen = new Set();
  const result = [];
  for (let idx = 0; idx < apiEvents.length; idx++) {
    const row = apiEvents[idx];
    const dateValue = row?.date || row?.event_date;
    const parsed = safeParseDate(dateValue);
    const hasValidDate = !Number.isNaN(parsed.getTime());
    const month = row?.month || monthCodeFromDate(dateValue) || "JAN";
    const year = row?.year || (hasValidDate ? parsed.getFullYear() : 2026);
    const title = row?.title || "Untitled Event";
    const dateStr = hasValidDate ? parsed.toISOString().slice(0, 10) : "2026-01-01";
    const dedupKey = title + "__" + dateStr;
    if (seen.has(dedupKey)) continue;
    seen.add(dedupKey);
    result.push({
      id: row?.id ?? idx + 1,
      title,
      category: row?.category || "all",
      country: row?.country || "Unknown",
      city: row?.city || "TBA",
      date: dateStr,
      month,
      year,
      visaRequired: typeof row?.visaRequired === "boolean"
        ? row.visaRequired
        : row?.visaRequired === "Visa Required"
          ? true
          : row?.visaRequired === "Visa Free"
            ? false
            : !!row?.visa_required,
      image: row?.image || row?.image_url || row?.imageUrl || FALLBACK_IMAGE,
      tag: row?.tag || "Event",
    });
  }
  return result;
}

export function getAvailableYears(events) {
  const years = [...new Set((events || []).map((eventItem) => eventItem?.year).filter(Boolean))];
  return years.sort((a, b) => a - b);
}


